
import { useQuery, useMutation, useQueryClient, useInfiniteQuery } from '@tanstack/react-query';
import { API_ENDPOINTS } from '../data/client/api-endpoints';
import { getConcalls } from './client/concall-client';
import { mapPaginatorData } from '../utils/data-mappers';


export const useConcallsQuery = (params) => {
    //console.log("params=====",params)
  const { data, error, isLoading } =  useQuery({
    queryKey: ["company-concalls", params.tag],
    queryFn: async ({ pageParam = 1 }) => getConcalls.get( { tag:params.tag, ...params } ),
    
  });

  //console.log("concall data====", data)

  return {
    records: data?.data,    
    paginatorInfo: mapPaginatorData(data),
    error,
    isLoading,
  };
};

export const useAllConcallsInfiniteQuery = ({sq, limit = 10 }) => {
  return useInfiniteQuery({
    queryKey: ["all-concalls", sq, limit],
    queryFn: ({ pageParam = 1 }) =>
      getConcalls.home({
        page: pageParam,
        limit,
        search:sq
      }),

    getNextPageParam: (lastPage) =>
      lastPage.current_page < lastPage.last_page
        ? lastPage.current_page + 1
        : undefined,
  });
};
